/**
***************************************************************************
* NAME 			: ChatLogsSummary
* PROPS	 		: None
* RETURNS 		: Display the chat logs on the dashboard
* LAST MODIFIED 	: July 22, 2025
***************************************************************************
*/

import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../../context/auth-context';
import NotificationContext from '../../../context/notification-context';
import useHttp from '../../../hooks/use-http';
import LoadingSpinner from '../../../components/UI/LoadingSpinner';
import { getChats } from '../../../api/ai-agent';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

const ChatLogsSummary = () => {
	const authCtx = useContext(AuthContext);
	const notifyCtx = useContext(NotificationContext);

	const [chats, setChats] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(true);

	const { sendRequest, status, data, error } = useHttp(getChats);

	useEffect(() => {
		if (status === 'completed') {
			if (error !== null) {
				// notifyCtx.displayNotification(
				// 	"ERROR",
				// 	error
				// )
				setErrorMessage(error);
			} else if (!data['success']) {
				// notifyCtx.displayNotification(
				// 	"ERROR",
				// 	data['status_code'] + ': ' + data['status']
				// )
				setErrorMessage(data['status_code'] + ': ' + data['status']);
			} else {
				// console.log('CHAT LOG DATA');
				// console.log(data['data']);

				setErrorMessage("");
				setChats(data['data']);
			}
			setIsLoading(false);

			// Reset timeout
			// authCtx.updateExpiration();
		}
	}, [status, error, data]);

	useEffect(() => {
		const requestData = {
			token: authCtx.token,
			dashboard: authCtx.dashboard,
			top: 5,
			display: "summary"
		};

		// console.log('REQUEST DATA');
		// console.log(requestData);

		sendRequest(requestData);
	}, [sendRequest]);

	return (
		<>
			{ isLoading && <LoadingSpinner /> }
			{ !isLoading && errorMessage &&
				<article>
					<div className="article_copy">
						<p>{errorMessage}</p>
					</div>
				</article>
			}

			{ !isLoading && !errorMessage && (chats.length == 0) &&
				<article>
					<div className="article_copy">
						<p>No chat logs to display</p>
					</div>
				</article>
			}
			{ !isLoading && !errorMessage && (chats.length > 0) &&
				<>
					<Splide options={ { rewind: true } } aria-label="Chat Logs">
						{chats.map((chat) => 
							<SplideSlide key={chat.id}>
								<article>
									<div className="article_copy">
										<h3 className="article_head chat-logs"><Link to={'/chat-logs/' + chat.id} className="excel">{chat.message}</Link></h3>
										<p><em>{chat.lastAction} on {chat.displayLastMessageSummaryMoment}</em></p>
									</div>
								</article>
							</SplideSlide>
						)}
					</Splide>

					<p><Link to="/chat-logs/">See all</Link></p>
				</>
			}
		</>
	)
}

export default ChatLogsSummary;